module.exports = __webpack_public_path__ + "static/media/Dragnet Alpha Vector 1.980946a0.svg";